// A page shown in Ask Ogma's side window (Craig, 31 Oct 2026: "without leaving the chat page"): the app opens the page in
// a frame beside the chat, on the same address and the same sign-in, and the page shows without the menu, the Ask bar
// or the demo banner. The person acts on it with its own buttons, as on the full page.

/** True inside the side window's frame (the app framed by itself); never in a normal tab. */
export function isEmbedded(): boolean {
  try {
    return typeof window !== "undefined" && window.self !== window.top;
  } catch {
    // A frame from another origin cannot read its parent: never the side window, which is the same origin.
    return false;
  }
}
